<template>
	<div id="searchDriver">
		<section class="content-header">
			<div class="container-fluid">
				<div class="row mb-2">
					<div class="col-md-6 col-12">
						<h1>{{ $t("label.search_driver")}}</h1>
					</div>
					<div class="col-md-6">
						<ol class="breadcrumb float-sm-right">
							<li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
							<li class="breadcrumb-item active">{{ $t("label.driver")}}</li>
						</ol>
					</div>
				</div>
			</div>
		</section>

		<div class="content">
			<div class="container-fluid">
				<div class="card card-success card-outline">
					<div class="card-header px-2">
						<h3 class="card-title">{{ $t("label.search_driver")}}</h3>
						<div class="card-tools">
							<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.search ? $t('label.expand') : $t('label.collapse')" @click="collapse.search = !collapse.search">
								<fa :icon="collapse.search ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
							</button>
						</div>
					</div>
					<div class="card-body">
						<table class="table table-sm table-bordered tblfind" cellspacing="0" cellpadding="0">
							<tr>
								<th width="20%">{{ $t("label.name")}}</th>
								<th width="20%">{{ $t("label.criteria")}}</th>
								<th width="30%">{{ $t("label.value_1")}}</th>
								<th width="30%">{{ $t("label.value_2")}}</th>							
							</tr>
							<tr>
								<th>{{ $t("label.fullname")}}</th>
								<td>
									<div class="form-group">
										<select v-model="fullname.criteria" class="form-control" id="fullname" name="fullname">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select> 
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="fullname.v1" name="fullname_v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('fullname_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="fullname.v2" name="fullname_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('fullname_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.nationality")}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" id="nationality" v-model="nationality.criteria" name="nationality">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">										
										<v-select v-if="nationality.criteria == 'all'"
											v-model="nationality.v1"
											name="nationality_v1"
											class="nationality_v1" 
											disabled
											:options="countries"
											label="name">
										</v-select>
										<v-select v-else
											v-model="nationality.v1"
											name="nationality_v1" 
											class="nationality_v1"                                  
											v-validate="'required'"
											:options="countries"
											label="name">
										</v-select>
										<span class="error_smg">{{ errors.first('nationality_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="nationality.v2" name="nationality_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('nationality_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.passport")}}</th>
								<td>
									<div class="form-group">
										<select v-model="passport_number.criteria" class="form-control" id="passport" name="passport">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
										</select> 
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="passport_number.v1" name="passport_v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('passport_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="passport_number.v2" :data-vv-as="$t('label.passport')" name="passport_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('passport_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.identity_card")}}</th>
								<td>
									<div class="form-group">
										<select v-model="identity_card_number.criteria" class="form-control" id="identity" name="identity">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="identity_card_number.v1" name="identity_v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('identity_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control"  v-model="identity_card_number.v2" name="identity_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('identity_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.gender")}}</th>
								<td>
									<div class="form-group">
										<select v-model="gender.criteria" class="form-control" id="gender" name="gender">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<select class="form-control gender_v1" v-model="gender.v1" :data-vv-as="$t('label.gender')" name="gender_v1" v-validate="'required'"  disabled>
											<option value="m">{{$t('label.male')}}</option>
											<option value="f">{{$t('label.female')}}</option>
										</select>
										<span class="error_smg">{{ errors.first('gender_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control"  v-model="gender.v2" :data-vv-as="$t('label.gender')" name="gender_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('gender_v2') }}</span>
									</div>
								</td>
							</tr>
						</table>
					</div>
					<div class="card-footer">
						<button data-id="search" type="button" class="btn btn-sm btn-primary float-right" @click.prevent="searchDriver(1, 'created_at', 'asc')"><fa :icon="fas.faSearch" class="left fa fa-circle-o nav-icon" />{{ $t('label.search') }}</button>
					</div>
				</div>

				<div class="card card-success card-outline">
					<div class="card-header px-2">
						<h3 class="card-title">{{ $t("label.driver")}}</h3>
						<div class="card-tools">
							<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.display ? $t('label.expand') : $t('label.collapse')" @click="collapse.display = !collapse.display">
								<fa :icon="collapse.display ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
							</button>
						</div>
					</div>
					<div class="card-body">
						<div class="table-responsive" v-if="drivers.length > 0">
							<table class="table table-bordered mb-0">
								<thead>
									<tr class="cursor-pointer">
										<th nowrap></th>
										<th nowrap @click="searchDriver(1, 'last_name', order_type, true)">{{$t('label.fullname')}}</th>
										<th nowrap @click="searchDriver(1, 'gender', order_type, true)">{{$t('label.gender')}}</th>
										<th nowrap @click="searchDriver(1, 'identity_card_number', order_type, true)">{{$t('label.identity_card')}}</th>
										<th nowrap @click="searchDriver(1, 'passport_number', order_type, true)">{{$t('label.passport')}}</th>
										<th nowrap @click="searchDriver(1, 'address', order_type, true)">{{$t('label.address')}}</th>
										<th nowrap @click="searchDriver(1, 'created_at', order_type, true)">{{$t('label.created_at')}}</th>
										<th nowrap style="witdh: 1%;"></th>
									</tr>
								</thead>
								<tbody  >
									<tr v-for="(driver, index) in drivers" :key="index" :value="driver.code">
										<td nowrap>{{(pageNumber*10-10)+index+1}}</td>
										<td nowrap>{{driver.last_name}} {{driver.first_name}}</td>
										<td nowrap>{{driver.gender.toUpperCase()}}</td>
										<td nowrap>{{driver.identity_card_number}}</td>
										<td nowrap>{{driver.passport_number}}</td>
										<td nowrap v-if="driver.address.length >= 30">{{driver.address.substring(0, 30)}}...</td>
										<td nowrap v-else>{{driver.address}}</td>
										<td nowrap>{{driver.created_at}}</td>
										<td nowrap style="text-align:center">
											<router-link :to="{ name:'ViewDriver', params:{ id: driver.uuid }}" :title="$t('label.view')" class="mr-2" v-if="$hasPermission('tempvehicle.driver.view')" target="_blank">
                        <fa :icon="fas.faEye"/>
                      </router-link>
											<router-link :to="{ name: 'EditDriver', params: { id: driver.uuid }}" class="mr-1" :title="$t('label.edit')" v-if="$hasPermission('tempvehicle.driver.edit')" target="_blank">
                        <fa :icon="fas.faEdit" style="color: green;"/>
                      </router-link>

											<a href="javascript: void(0)" @click="deleteDriver(driver.uuid)" :title="$t('label.delete')" v-if="permission.deleteDriver">
												<fa :icon="fas.faTrash" style="color: red;"/>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="callout callout-success" v-else>
							<label>{{$t('label.no_data')}}</label>
						</div>
					</div>
					<div class="card-footer" v-if="drivers.length > 0">
						<paginate class="mb-0"
							:page-count="last_page"
							:force-page="forcepage"
							:page-range="3"
							:margin-pages="2"
							:click-handler="searchDriver"
							:container-class="'pagination float-right'"
							:prev-text="'Prev'"
							:next-text="'Next'"
							:page-class="'page-item'"
							:active-class="'active'"
							:prev-link-class="'page-link'"
							:next-link-class="'page-link'"
							:page-link-class="'page-link'"
							ref="paginate">
						</paginate>
					</div>
				</div>
			</div>
		</div>
	</div>  
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";
export default {
	name: 'SearchDriver',
    data(){
      	return {
			permission:{
				deleteDriver: false,
			},
			baseURI : '',
			forcepage: 1,
			pageNumber:1,
			last_page: 0,
			countries: [],
			fullname:{
				criteria: "all",
				v1:'',
				v2:''
			},
			nationality:{
				criteria: "all",
				v1:'',
				v2:''
			},
			passport_number:{
				criteria: "all",
				v1:'',
				v2:''
			},
			identity_card_number:{
				criteria: "all",
				v1:'',
				v2:''
			},
			gender:{
				criteria:"all",
				v1:'',
				v2:''
			},
			drivers:[],
			order_by:'created_at',
			order_type:'asc',
			order_type_after_sort:'',
			collapse:{
				search: false,
				display: false,
			}
      	}
	},
	watch: {
		"fullname.criteria" : function(val){
			if(val == "all"){
				this.fullname.v1 = '';
				this.errors.remove('fullname_v1');
				return this.fullname;
			}
		},
		"nationality.criteria": function(val){
			if(val == "all"){
				this.nationality.v1 = '';
				this.nationality.v2 = '';
				this.errors.remove('nationality_v1');
				return this.nationality;
			}	
		},
		"identity_card_number.criteria": function(val){
			if(val == "all"){
				this.identity_card_number.v1 = '';
				this.identity_card_number.v2 = '';
				this.errors.remove('identity_v1');	
				return this.identity_card_number;
			}	
		},
		"passport_number.criteria": function(val){
			if(val == "all"){
				this.passport_number.v1 = '';
				this.passport_number.v2 = '';
				this.errors.remove('passport_v1');
				return this.passport_number;
			}	
		},
		"gender.criteria": function(val){
			if(val == "all"){
				this.gender.v1 = '';
				this.gender.v2 = '';
				this.errors.remove('gender_v1');
				return this.gender;
			}	
		},
	},
    computed: {
        fas() {
            return fas;
		},		
	},
	updated(){
		$(".tblfind").find("select").on("change",function(){
			if($(this).val() == "all"){
				$(this).parents("tr").find("input").val("");
				$(this).parents("tr").find("input").prop("disabled",true);
				$(this).parents("tr").find(".vdp-datepicker").find("input[name='"+$(this).prop("name")+"_v1']").css("background-color", "#e9ecef");
				
				$(this).parents("tr").find(".nationality_v1 div.dropdown-toggle , .nationality_v1 input, .nationality_v1 button, .nationality_v1 i").css("background-color", "rgba(235, 238 ,220 ,0)");
				$(this).parents("tr").find(".nationality_v1").addClass("disabled");

				$(this).parents("tr").find(".gender_v1").prop("disabled", true);

				$(this).parents("tr").find("select.value").val("");
				$(this).parents("tr").find("select.value").prop("disabled",true);
			}else{
				$(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v1']").removeAttr("disabled");
				$(this).parents("tr").find("select[name='"+$(this).prop("name")+"_v1']").removeAttr("disabled");
				// For Datepicker
				$(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v1']").removeAttr("readonly");
				$(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v1']").removeAttr("disabled");
				$(this).find(".vdp-datepicker").find("input[name='"+$(this).prop("name")+"_v1']").css("background-color", "white");
				$(this).parents("tr").find(".vdp-datepicker").find("input[name='"+$(this).prop("name")+"_v1']").css("background-color", "white");
				// For Vselect 
				
				// $("#nationality_v1").removeClass("disabled");
				$(this).parents("tr").find(".nationality_v1").removeClass("disabled");
				$(this).parents("tr").find(".nationality_v1 div.dropdown-toggle , .nationality_v1 button, .nationality_v1 i").css("background-color", "white");
				$(this).parents("tr").find(".nationality_v1").find("input").removeClass("disabled");
				$(this).parents("tr").find(".nationality_v1").find("input").removeAttr("disabled");

				$(this).parents("tr").find(".gender_v1").find("input").removeClass("disabled");
				$(this).parents("tr").find(".gender_v1").find("input").removeAttr("disabled");
				
				if($(this).val() == "between"){
					$(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v2']").removeAttr("disabled");
					// For Datepicker
					$(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v2']").removeAttr("readonly");
					$(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v2']").removeAttr("disabled");
				}else{
					$(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v2']").val("");
					$(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v2']").prop("disabled",true);
					// For Datepicker
					$(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v2']").prop("disabled",true);
				}
			}
		});
	},
    mounted () {
		this.getCountries();
		this.searchDriver(1, 'created_at', 'asc');
		$(".nationality_v1 div.dropdown-toggle, .nationality_v1 input, .nationality_v1 button, .nationality_v1 i").css("background-color", "rgba(235, 238 ,220 ,0)");
    },
    methods: {
		searchDriver(pageNumber, order_by = null, order_type=null, searched = false) {
			this.forcepage = pageNumber;
			this.$validator.validate().then(result => {
				if (result){
					(order_by == null ? order_by = this.order_by : order_by);
					(order_type == null ? order_type = this.order_type_after_sort : order_type);
					this.$store.state.loading.status = true;
                    let url = this.baseURI + 'backend/drivers/search?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
                    GDCE_Client.requestApi("POST", url, {
                        fullname: this.fullname,
                        nationality: this.nationality,
                        passport_number: this.passport_number,
						identity_card_number: this.identity_card_number,
						gender: this.gender
                    }).then(response => {
						this.$store.state.loading.status = false;
						this.drivers = response.data.data;
						this.last_page = response.data.last_page;
						(order_type == 'desc' ? this.order_type = 'asc' : this.order_type='desc');
						this.order_type_after_sort = order_type;
						this.order_by = order_by;
						this.permission.deleteDriver = this.$hasPermission('tempvehicle.driver.delete');
                    });
				}
				if(searched)
					this.$refs.paginate.selected = 1;
			});
		},
		getCountries() {
            this.$store.state.loading.status = true;
            let url = this.baseURI + 'reference/countries';
            GDCE_Client.requestApi("GET", url).then(response => {
				this.countries = response.data;
                this.$store.state.loading.status = false;
            });
        },
		clearCreatedAtTodate(data){
			this.created_at.v2 ='';
		},		
		deleteDriver(uuid){
			this.$swal({
				title: this.$t('label.confirm_delete'),
				icon: "warning",
				buttons: true,
				dangerMode: true
			}).then(willDelete => {	
				if (willDelete) {
					let url = this.baseURI + "/backend/drivers/" + uuid;
					GDCE_Client.requestApi("DELETE", url).then(response => {
						this.searchDriver(this.pageNumber, null, null);
					});
				}
			});
		}
    }
}
</script>

<style scoped>
	.tblfind tr td {
		padding: 0px !important;
		border-top: 0px !important;
		line-height: 30px;
	}
	.tblfind tr th {
		line-height: 30px;
	}
	.form-control{
		border-radius: 0;
	}
	.form-group{
		margin-bottom: 0;
	}
	input, select{
		margin: 0;
	}
	.error_smg{
		color:red;
	}
	.disabled {
      	pointer-events:none;
      	color: #bfcbd9;
      	cursor: not-allowed;
      	background-image: none;
      	background-color: rgba(233, 236, 239, 1) !important;
      	border-color: #e9ecef;   
    }
	.v-select.disabled .dropdown-toggle, .v-select.disabled .dropdown-toggle .clear, .v-select.disabled .dropdown-toggle input, .v-select.disabled .open-indicator, .v-select.disabled .selected-tag .close {
		cursor: not-allowed;
		background-color: rgba(233, 236, 239, 1) !important;
	}
</style>
